import React, { useState } from 'react';
import { ReactComponent as EditIcon } from '../../../../assets/svg/ai-agents/editIcon.svg'
import { ReactComponent as DeleteIcon } from '../../../../assets/svg/ai-agents/deleteIcon.svg'
import { ReactComponent as StringIcon } from '../../../../assets/svg/ai-agents/stringIcon.svg'
import { ReactComponent as NumberIcon } from '../../../../assets/svg/ai-agents/numberIcon.svg'
import { ReactComponent as BooleanIcon } from '../../../../assets/svg/ai-agents/booleanicon.svg'
import { ReactComponent as EnumIcon } from '../../../../assets/svg/ai-agents/enumIcon.svg'
// import { ReactComponent as JsonIcon} from '../../../../assets/svg/ai-agents/jsonIcon.svg'
import { ReactComponent as ArrayOfString } from '../../../../assets/svg/ai-agents/arrayofstringsIcon.svg'
import { Checkbox, Input, Select, Tag } from "antd";
import style from "./style.module.scss"
import { VariablesProps, VariablesType } from './types';
import { pageVariants1 } from './framerAnimations';
import { motion } from 'framer-motion';
const { Option } = Select;

export const VariablesLists = ({ hideFields, variables, setVariables, hideAddFields, showAddFields, canEditAgents }: VariablesProps) => {
    const valueTypes = [
        { label: "String", value: "string", icon: StringIcon },
        { label: "Number", value: "number", icon: NumberIcon },
        { label: "Enum", value: "string", icon: EnumIcon },
        // { label: "Json", value: "object", icon: JsonIcon },
        { label: "Boolean", value: "boolean", icon: BooleanIcon },
        // { label: "Enum", value: "enum", icon: EnumIcon },
        { label: "Array of Strings", value: "array", icon: ArrayOfString },
    ]
    // const [outputVariables, setOutputVariables] = useState<VariablesType[]>([])
    const [enumVariables, setEnumVariables] = useState("");
    const [formData, setFormData] = useState<VariablesType>({
        id: 0,
        name: '',
        description: '',
        required: false,
        enum: [],
        type: 'string'
    });
    const [editingId, setEditingId] = useState<number | null>(null);
    const [errors, setErrors] = useState({
        name: '',
        description: '',
        type: '',
        enumValues: ''
    });

    // Validate form fields
    const validate = () => {
        let hasError = false;
        const newErrors = { name: '', description: '', type: '', enumValues: '' };
        const { enum: enumVariables = [] } = formData || {};

        if (!formData.name.trim()) {
            newErrors.name = 'Enter parameter name';
            hasError = true;
        }

        if (!/^[a-zA-Z0-9_-]{1,64}$/.test(formData?.name || '')) {
            newErrors.name = 'Enter a valid name without special characters or spaces';
            hasError = true;
        }

        if (!formData.description.trim()) {
            newErrors.description = 'Enter description';
            hasError = true;
        }

        if (formData.type === "enum" && enumVariables && enumVariables?.length <= 0){
            newErrors.enumValues = 'Enter enum values';
            hasError = true;
        }

        if (!formData.type) {
            newErrors.type = 'Select type';
            hasError = true;
        }

        setErrors(newErrors);
        return !hasError; // Return true if no errors
    };

    // Update form data based on input field changes
    const handleInputChange = (field: keyof VariablesType, value: any) => {
        setErrors((prevState) => {
            return {
                ...prevState,
                [field]: ""
            }
        })
        if (field === "enum") {
            setFormData({
                ...formData,
                enum: formData.enum ? [...formData.enum, value] : [value]
            });
            return
        }
        setFormData({
            ...formData,
            [field]: value
        });
    };

    // Handle form submission (add/edit)
    const handleAddOrEditVariable = () => {
        if (!validate()) return; // Prevent submission if validation fails

        if (editingId !== null) {
            // If editing, update the existing variable
            const updatedVariables = variables.map((variable) =>
                variable.id === editingId
                    ? { ...formData, id: editingId }
                    : variable
            );
            setVariables(updatedVariables);
            setEditingId(null); // Clear editing state
        } else {
            // If not editing, create a new variable
            const newVariable = {
                ...formData,
                id: variables.length + 1 // Generate new id
            };
            setVariables([...variables, newVariable]);
        }

        hideAddFields(false)
        // Reset the form
        setFormData({
            id: 0,
            name: '',
            description: '',
            enum: [],
            required: false,
            type: 'string'
        });
        setErrors({ name: '', description: '', type: '', enumValues: '' }); // Clear errors
    };

    // Handle edit click
    const handleEdit = (id: number) => {
        hideAddFields(true)
        const variableToEdit = variables.find((variable) => variable.id === id);
        if (variableToEdit) {
            setFormData(variableToEdit);
            setEditingId(id);
        }
    };

    // Handle delete click
    const handleDelete = (id: number) => {
        const filteredVariables = variables.filter((variable) => variable.id !== id);
        setVariables(filteredVariables);
    };

    const handleKeyCapture = (e: React.KeyboardEvent<HTMLInputElement>) => {
        if (e.key === 'Enter' && enumVariables.trim() !== '') {
            setFormData((prevState: VariablesType) => {
                return {
                    ...prevState,
                    enum: prevState?.enum && prevState?.enum.length > 0
                        ? [...prevState.enum, enumVariables]
                        : [enumVariables]
                };
            });
            setEnumVariables('');
        }
    };

    const clearTags = (e: any) => {
        setFormData((prevState: VariablesType) => {
            return {
                ...prevState,
                enum: prevState?.enum?.filter((val) => val != e)
            };
        });
    }

    return (
        <motion.div
            initial="hidden"
            animate="visible"
            exit="exit"
            variants={pageVariants1}
            style={{ background: "white", borderRadius: 10 }}>
            {showAddFields &&
                <motion.div
                    initial="hidden"
                    animate="visible"
                    exit="exit"
                    variants={pageVariants1}
                    style={{ display: "flex", flexDirection: "row", padding: 10 }}>
                    <div className={style.typeFieldsContainer}>
                        <span className={style.fieldHeader}>Parameter Name</span>
                        <Input
                            disabled={!canEditAgents}
                            style={{ width: "100%", color: "#606060" }}
                            value={formData.name}
                            className={style.createAgentName}
                            placeholder="Name"
                            onChange={(e) => handleInputChange('name', e.target.value)}
                        />
                        {errors.name && <span className={style.errorMessage}>{errors.name}</span>}
                    </div>


                    <div className={style.typeFieldsContainer} style={{ paddingLeft: 10, width: 120 }}>
                        <span className={style.fieldHeader}>Type</span>
                        <Select
                            disabled={!canEditAgents}
                            mode='default'
                            dropdownClassName='output-value-types'
                            value={formData.type}
                            className="valueTypes"
                            placeholder="Select Type"
                            optionLabelProp="label"
                            onChange={(value) => handleInputChange('type', value)}
                        >
                            {valueTypes.map((type) => {
                                const IconComponent = type.icon;
                                return (
                                    <Option key={type.label} value={type.value} label={<IconComponent style={{ marginTop: 5 }} />}>
                                        <div style={{ display: "flex", alignItems: "center", padding: 8 }}>
                                            <IconComponent style={{ marginRight: 5 }} /> {type.label}
                                        </div>
                                    </Option>
                                )
                            })}
                        </Select>
                        {errors.type && <span className={style.errorMessage}>{errors.type}</span>}
                    </div>

                    <div className={style.typeFieldsContainer} style={{ paddingLeft: 10 }}>
                        <span className={style.fieldHeader}>{"Description"}</span>
                        <Input
                            disabled={!canEditAgents}
                            style={{ width: "100%", color: "#606060" }}
                            value={formData.description}
                            className={style.createAgentName}
                            placeholder={"Description"}
                            onChange={(e) => {
                                // if(formData.type === "enum"){
                                //     setEnumVariables(e.target.value)
                                //     return
                                // }
                                handleInputChange('description', e.target.value)
                            }}
                        />
                        {errors.description && <span className={style.errorMessage}>{errors.description}</span>}
                    </div>
                </motion.div>}
            {formData.type === "enum" && <div className={style.typeFieldsContainer} style={{ padding: "0px 10px 0px 10px", marginBottom: 10 }}>
                <span className={style.fieldHeader}>{"List"}</span>
                <Input
                    disabled={!canEditAgents}
                    style={{ width: "100%", color: "#606060" }}
                    value={enumVariables}
                    className={style.createAgentName}
                    onKeyPressCapture={handleKeyCapture}
                    placeholder={"List"}
                    onChange={(e) => {
                        if (formData.type === "enum") {
                            setErrors({...errors, enumValues: ''})
                            setEnumVariables(e.target.value)
                            return
                        }
                    }}
                />
                {errors.enumValues && <span className={style.errorMessage}>{errors.enumValues}</span>}
            </div>}
            {formData.enum && formData.enum?.length > 0 && <div style={{ padding: 5 }}>
                {formData.enum && formData.enum.map((variable, index) => (
                    <Tag
                        className={style.enumVariables}
                        onClose={() => {clearTags(variable)}}
                        key={variable}
                        closable={canEditAgents}
                    >
                        {variable}
                    </Tag>
                ))}
            </div>}

            {showAddFields && <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between", padding: 10 }}>
                <div>
                    <Checkbox style={{ height: 18, width: 18 }} checked={formData.required} 
                        disabled={!canEditAgents}
                        onChange={(e) => handleInputChange('required', e.target.checked)}
                    />
                    <span style={{
                        paddingLeft: 10,
                        color: "#767B83",
                        fontSize: 14,
                        fontWeight: 400,
                        marginBottom: 5
                    }}>Required</span>
                </div>


                <div style={{ display: "flex" }}>
                    <button className={style.cancelButton}
                        onClick={() => {
                            if (variables.length <= 0) {
                                hideFields(false)
                            }
                            hideAddFields(false)
                            setFormData({
                                id: 0,
                                name: '',
                                description: '',
                                required: false,
                                type: 'string'
                            })
                        }}
                        style={{ width: 61, height: 26, padding: 3 }}
                    >Cancel</button>
                    <button className={style.saveAgentButton} style={{ width: editingId !== null ? 70 : 46, height: 26, padding: 3 }} onClick={handleAddOrEditVariable}>
                        {editingId !== null ? 'Update' : 'Add'}
                    </button>
                </div>
            </div>}

            {showAddFields && variables?.length > 0 && <div className={style.dashBorderDivider}></div>}
            <div>
                {variables.map((variable: VariablesType) => {
                    return (
                        <div className={style.variableCard}>
                            <div className={style.variableCardHeader}>
                                <div className={style.variableCardName}>{variable.name}</div>
                                <div className={style.variableCardDivider}></div>
                                <div className={style.variableCardType}>
                                    {valueTypes.find((type) => variable.type === type.value)?.label || variable.type}
                                </div>
                                {variable.required && <div className={style.variableCardRequired}>{"Required"}</div>}
                                <div className={style.variableCardDivider}></div>
                                <div className={style.variableCardActions}>
                                    {canEditAgents && <EditIcon style={{ cursor: "pointer" }} onClick={() => handleEdit(variable.id)} />}
                                    {canEditAgents && <DeleteIcon style={{ cursor: "pointer" }} className={style.variableCardActionsDelete} onClick={() => handleDelete(variable.id)} />}
                                </div>
                            </div>
                            {variable.description && <div className={style.variableCardDescription}>{variable.description}</div>}
                            {variable.enum && variable.enum?.length > 0 && <div style={{ padding: 5, marginTop: 5 }}>
                                {variable.enum && variable.enum.map((variable, index) => (
                                    <Tag
                                        className={style.enumVariables}
                                        key={variable}
                                        closable={false}
                                    >
                                        {variable}
                                    </Tag>
                                ))}
                            </div>
                            }
                            <div className={style.variableCardFooterDivider}></div>
                        </div>
                    )
                })}
            </div>
        </motion.div>
    )

}